import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Image, Nav, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";
import ProductosCarousel from "../components/ProductosCarousel";
import banner from "../assets/imagen.jpg";
import logoFacach from "../assets/fotos/ISOLOO.png";
import Logo2 from "../assets/isotipo.png";
import "../components/operaciones.css";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

const API_URL = "https://facach.coop.hn/api";

const CATEGORIES = [
  { key: "captaciones", titulo: "Captaciones" },
  { key: "creditos", titulo: "Créditos" },
  { key: "unired", titulo: "FACACH UNIRED" },
];

// Fallback con los datos estáticos originales
const FALLBACK = {
  captaciones: [
    { id: 1, titulo: "Depósito a Plazo Fijo", descripcion: "FEC y Fondos Normales. Ofrecer a cooperativas afiliadas y no afiliadas una forma segura y rentable de hacer crecer sus recursos.", tipo_moneda: ["Lempiras", "Dólares"], plazos: [90, 180, 270, 360, 390], tasa_interes: "Conforme a tasa de interés de mercado financiero vigente.", nota: "Al cancelar anticipadamente no se penalizan los intereses.", icono: Logo2 },
    { id: 2, titulo: "Depósito de Ahorro", descripcion: "Instrumentos financieros mediante los cuales las cooperativas afiliadas y no afiliadas mantienen recursos líquidos en FACACH.", tipo_moneda: ["Lempiras", "Dólares"], icono: Logo2 },
    { id: 3, titulo: "Inversión Cooperativa", descripcion: "Producto diseñado para la colocación estratégica de Certificados de Depósito a Plazo Fijo.", plazos: [90, 180, 360], icono: Logo2 },
  ],
  creditos: [
    { id: 4, titulo: "Préstamo Automático", descripcion: "Solución de financiamiento inmediata, dirigida a cooperativas afiliadas que requieren liquidez ágil.", destino: ["Capital de Trabajo", "Capital de Inversión Fija", "Liquidez"], plazos: ["Hasta 36 meses para Capital de Trabajo", "Hasta 84 meses para Inversión Fija"], tasa_interes: "9%", nota: "Forma de Pago: Cuotas Fijas Niveladas", icono: Logo2 },
    { id: 5, titulo: "Crédito FACOOPE", descripcion: "Solución crediticia diseñada para atender necesidades financieras de cooperativas afiliadas y no afiliadas.", destino: ["Capital de Trabajo", "Capital de Inversión Fija", "Liquidez"], plazos: ["Hasta 36 meses para Capital de Trabajo", "Hasta 84 meses para Inversión Fija"], tasa_interes: "11.5% Garantía Hipotecaria / 12.5% Garantía Mixta", garantias: ["Hipotecaria", "Cesión de Cartera", "Mixta"], nota: "Forma de Pago: Cuotas Fijas Niveladas", icono: Logo2 },
    { id: 6, titulo: "Raíz Cooperativa", descripcion: "Dirigido a cooperativas con inversiones activas en FACACH mediante Depósitos a Plazo Fijo.", destino: ["Capital de Trabajo", "Capital de Inversión Fija", "Liquidez"], plazos: ["Hasta 36 meses para Capital de Trabajo", "Hasta 84 meses para Inversión Fija"], tasa_interes: "Se aplica un 4% adicional sobre la tasa del certificado.", garantias: ["Hipotecaria", "Cesión de Cartera", "Mixta"], nota: "Forma de Pago: Cuotas Fijas Niveladas", icono: Logo2 },
    { id: 7, titulo: "Fondos FODESSE", descripcion: "Financiamiento para producción, transformación y comercialización dentro del sector cooperativo.", destino: ["Producción", "Transformación", "Comercialización"], plazos: ["Hasta 36 meses para Capital de Trabajo", "Hasta 60 meses para Inversión Fija"], tasa_interes: "10% (máx. 15% para afiliadas)", garantias: ["Garantía Prendaria", "Garantía Hipotecaria", "Mixta"], nota: "Forma de Pago: Cuotas Fijas Niveladas", icono: Logo2 },
    { id: 8, titulo: "Líneas de Crédito", descripcion: "Financiamiento flexible para cooperativas afiliadas y no afiliadas, con disponibilidad recurrente.", ventajas: ["Trámite ágil y simplificado", "15 años de vigencia", "Atención personalizada", "Tasa y plazo según negociación"], icono: Logo2 },
  ],
  unired: [
    { id: 9, titulo: "Remesas con UNIRED", descripcion: "Facilita el envío de remesas con pagos rápidos y seguros en ventanilla o acreditación automática.", ventajas: ["Pago en Ventanilla", "Directo a Cuenta Automático"], icono: Logo2 },
    { id: 10, titulo: "Transferencias ACH", descripcion: "Sistema de transferencias electrónicas para enviar fondos a cooperativas o bancos.", ventajas: ["Aplicación inmediata", "Transferencias todos los días", "Disponibilidad 6:00 a.m. - 10:00 p.m."], icono: Logo2 },
    { id: 11, titulo: "Págalo Todo", descripcion: "Sistema de cobros en tiempo real para pago de servicios y recargas mediante UNIRED.", ventajas: ["Recargas Tigo", "Servicios públicos (EEH, Hondutel)", "Recaudación: Cable Color, Lady Lee"], icono: Logo2 },
  ],
};

// Convierte un row de BD al formato que espera ProductosCarousel
function mapProduct(r) {
  return {
    ...r,
    icono: Logo2,
    tipo: r.ventajas?.length ? r.ventajas : undefined,
    subtitulo: '',
  };
}

const Operaciones = () => {
    const { settings } = useSiteSettings();
    const bannerSrc = settings.banner_image
      ? `https://facach.coop.hn${settings.banner_image}`
      : fallbackBanner;
  const [productos, setProductos] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);
  const [activo, setActivo] = useState("captaciones");

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/financial-products`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) {
          const grouped = { captaciones: [], creditos: [], unired: [] };
          json.data.forEach(r => {
            if (grouped[r.category]) grouped[r.category].push(mapProduct(r));
          });
          // Solo reemplaza las categorías que tienen datos
          setProductos(prev => ({
            captaciones: grouped.captaciones.length ? grouped.captaciones : prev.captaciones,
            creditos: grouped.creditos.length ? grouped.creditos : prev.creditos,
            unired: grouped.unired.length ? grouped.unired : prev.unired,
          }));
        }
      } catch (err) {
        console.error("Error cargando productos financieros:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetch_();
  }, []);

  const servicioActivo = CATEGORIES.find(s => s.key === activo);
  const itemsDelServicio = productos[activo] || [];

  return (
    <Container fluid className="p-0 operaciones-page">
      <NavbarFacach />

      <div className="banner-wrapper">
         <Image src={bannerSrc} alt="..." fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">OPERACIONES FINANCIERAS</h1>
        </div>

      </div>

      <Container className="mt-4">
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <h2 className="at-section-title">Nuestros Servicios</h2>
            <p className="at-section-subtitle">
              Ofrecemos a las cooperativas afiliadas y no afiliadas distintas opciones de
              financiamiento diseñados para atender diversas necesidades de capital
              de trabajo e inversión fija.
              Estos productos están diseñados para fortalecer la operatividad, mejorar
              la capacidad productiva y promover el crecimiento sostenible de las
              cooperativas, mediante condiciones competitivas y flexibles, ajustados a
              las particularidades de cada cooperativa
            </p>
          </Col>
        </Row>

        <Nav variant="tabs" activeKey={activo} onSelect={k => setActivo(k)} justify className="mb-4 operaciones-nav facach-sticky">
          {CATEGORIES.map(s => (
            <Nav.Item key={s.key}>
              <Nav.Link eventKey={s.key}>{s.titulo}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {loading ? (
          <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
        ) : (
          <Row className="justify-content-center g-4">
            <Col xs={12} md={10} lg={4}>
              <Card className="h-100 shadow-sm servicio-card servicio-card--feature">
                <Card.Body className="d-flex flex-column servicio-feature-body">
                  <div className="servicio-header d-flex align-items-center justify-content-center gap-2 mb-2">
                    <span className="servicio-header-logo">
                      <Image src={logoFacach} alt="FACACH" />
                    </span>
                    <h5 className="servicio-header-title m-0">{servicioActivo?.titulo}</h5>
                  </div>
                  <div className="text-muted small text-center mb-3">
                    Explora los productos y soluciones disponibles en esta área.
                  </div>
                  <div className="servicio-counter-wrap d-flex justify-content-center mb-2">
                    <div className="servicio-counter">
                      <div className="counter-label">Servicios</div>
                      <div className="counter-value">{itemsDelServicio.length}</div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={10} lg={8}>
              <ProductosCarousel
                items={itemsDelServicio}
                showTitle={false}
                interval={9000}
                indicators={true}
                controls={true}
                descriptionMode="full"
              />
            </Col>
          </Row>
        )}

        <div className="boton-centro my-4">
          <Button variant="primary" as={Link} to="/contacto_operaciones" className="cta-btn">
            Contáctanos para obtener más información
          </Button>
        </div>
        <div className="boton-centro my-4">
          <Button as="a" href="/documentos/catalogo.pdf" target="_blank" rel="noopener noreferrer"
            variant="link" className="producto-vermas-link mt-auto p-0">
            Haz clic para ver nuestro Catálogo
          </Button>
        </div>

        <SocialBar position="right" top="35%" size={42} rounded />
      </Container>
      <FooterFacach />
    </Container>
  );
};

export default Operaciones;